import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	popupStoryPointNonNegative: {
		id: 'issue-field-story-point-estimate-inline-edit.story-point-estimate.tooltip-label',
		defaultMessage: "Time for some positivity. Story point estimates can't be negative.",
		description:
			'Tooltip message that will be shown when the negative story point estimate is entered',
	},
});
